import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.995 4.85A2 2 0 0 0 25 3H7l-.15.005A2 2 0 0 0 5 5v22l.005.15A2 2 0 0 0 7 29h18l.15-.006A2 2 0 0 0 27 27V5zM7 5h18v22H7zm4 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m6.5 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M21 22a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-8.5-3.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M16 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m6.5 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M22 7a1 1 0 0 1 .993.883L23 8v6a1 1 0 0 1-.883.993L22 15H10a1 1 0 0 1-.993-.883L9 14V8a1 1 0 0 1 .883-.993L10 7zM11 9h10v4H11z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconEstimate = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconEstimate);
export default Memo;
